import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { LogOut } from 'lucide-react';
import { Button } from 'primereact/button';
import type React from 'react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const auth = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    auth.removeUser();
    auth.signoutRedirect();
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {auth.isAuthenticated && (
        <header className="bg-white shadow-sm">
          <div className="max-w-[calc(80rem+4cm)] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={handleLogoClick}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleLogoClick();
                }
              }}
              tabIndex={0}
              role="button"
            >
              <img src="/kasko-logo.svg" alt="Kasko" className="h-8" />
              <span className="h-8 flex items-center text-[42px] font-bold text-gray-900 leading-none">EDA</span>
            </div>
            <div className="flex items-center gap-4">
              <LanguageSwitcher />
              <span className="text-sm text-gray-600">
                {auth.user?.profile?.name || auth.user?.profile?.email || 'User'}
              </span>
              <Button icon={<LogOut size={16} />} onClick={handleLogout} className="p-button-text" title="Logout" />
            </div>
          </div>
        </header>
      )}
      <main className="max-w-[calc(80rem+4cm)] mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
    </div>
  );
};
